import React from "react";
import PropTypes from "prop-types";
import {
    ApprovalIcon, AttentionIcon,
    CrossIcon,
    EventIcon,
    InfoIcon,
    ProgressIcon,
    QuestionIcon
} from "uikit/assets/icons";
import TooltipWrapper from "uikit/components/Tooltip/TooltipWrapper";
import styles from "./IconTooltip.module.styl";

function IconTooltip({ name, icon, placement, children, trigger, iconText }) {
    // eslint-disable-next-line react/no-unstable-nested-components
    const Icon = (props) => {
        switch (icon) {
            case "question":
                return <QuestionIcon {...props} />;
            case "info":
                return <InfoIcon {...props} />;
            case "approval":
                return <ApprovalIcon {...props}/>
            case "event":
                return <EventIcon {...props}/>
            case "progress":
                return <ProgressIcon {...props}/>
            case "attention":
                return <AttentionIcon {...props}/>
            default:
                return <CrossIcon {...props} />;
        }
    };

    return (
        <TooltipWrapper
            placement={placement}
            trigger={[trigger]}
            overlayContent={<div className={styles.overlay}>{children}</div>}
            data-test-name={name}
        >
            {iconText != null ? (
                <div className={styles.iconText}>
                    <Icon />
                    {iconText}
                </div>
            ) : (
                <Icon />
            )}
        </TooltipWrapper>
    );
}

IconTooltip.propTypes = {
    name: PropTypes.string,
    icon: PropTypes.oneOf(["question", "info"]),
    placement: PropTypes.oneOf([
        "left",
        "right",
        "top",
        "bottom",
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight",
        "leftTop",
        "rightTop",
        "leftBottom",
        "rightBottom",
    ]),
    trigger: PropTypes.oneOf(["hover", "click", "focus"]),
    iconText: PropTypes.object,
};

IconTooltip.defaultProps = {
    placement: "bottom",
    icon: "question",
    trigger: "click",
};

export default IconTooltip;
